module.exports = __webpack_public_path__ + "static/media/icon-mail-no.9cb6a179.svg";